export default {"src":"/_next/static/media/left-back-icon.527982cd.svg","height":18,"width":26};